export enum Status {
    Init = 'Init',
    Loading = 'Loading',
    Loaded = 'Loaded',
    Error = 'Error'
}
